import React from 'react'
import { func, string, bool, node } from 'prop-types'
import { Image } from '@cobalt/cobalt-react-components'
import {
  SetupMFAStep,
  SetupMFAWebAuthnRegisterAnimation
} from '../../components'
import { SECURITY_KEY } from '../../constants/images'
import {
  NEXT,
  FINISH,
  SETUP_MFA_WEB_AUTHN_MESSAGE_START_REGISTRATION_STEP,
  SETUP_MFA_WEB_AUTHN_MESSAGE_REGISTER_STEP,
  SETUP_MFA_WEB_AUTHN_TITLE,
  SETUP_MFA_WEB_AUTHN_FOOTNOTE
} from '../../constants/ui.labels'
import { LEARN_MORE_ABOUT_SECURITY_KEYS } from '../../constants/links'

const SetupMFAWebAuthnStep = props => (
  <SetupMFAStep
    title={SETUP_MFA_WEB_AUTHN_TITLE}
    footnoteLabel={SETUP_MFA_WEB_AUTHN_FOOTNOTE}
    footnoteUrl={LEARN_MORE_ABOUT_SECURITY_KEYS}
    {...props}
  />
)

SetupMFAWebAuthnStep.propTypes = {
  subtitle: string.isRequired,
  boxContent: node.isRequired,
  buttonLabel: string.isRequired,
  buttonAction: func.isRequired,
  onCancel: func.isRequired,
  isProcessing: bool,
  errorCode: string,
  buttonDisabled: bool
}

export const StartRegistrationStep = ({
  onPrepareRegistration,
  ...otherProps
}) => (
  <SetupMFAWebAuthnStep
    subtitle={SETUP_MFA_WEB_AUTHN_MESSAGE_START_REGISTRATION_STEP}
    boxContent={<Image src={SECURITY_KEY} width={100} alt="" />}
    buttonLabel={NEXT}
    buttonAction={onPrepareRegistration}
    {...otherProps}
  />
)

StartRegistrationStep.propTypes = {
  onCancel: func.isRequired,
  onPrepareRegistration: func.isRequired,
  errorCode: string,
  isProcessing: bool
}

export const RegisterStep = ({
  onFinishRegistration,
  isValid,
  ...otherProps
}) => (
  <SetupMFAWebAuthnStep
    subtitle={SETUP_MFA_WEB_AUTHN_MESSAGE_REGISTER_STEP}
    boxContent={<SetupMFAWebAuthnRegisterAnimation isValid={isValid} />}
    buttonLabel={FINISH}
    buttonAction={onFinishRegistration}
    buttonDisabled={!isValid}
    {...otherProps}
  />
)

RegisterStep.propTypes = {
  onCancel: func.isRequired,
  onFinishRegistration: func.isRequired,
  onStartRegistration: func.isRequired,
  errorCode: string,
  isProcessing: bool,
  isValid: bool
}
